import type { HeuristicHint } from '@mtg-deck-tool/shared';

interface LandCountInputProps {
  value: number;
  onChange: (n: number) => void;
  hint: HeuristicHint;
}

/**
 * Number input for the desired land count, with a heuristic hint subtitle.
 */
export default function LandCountInput({ value, onChange, hint }: LandCountInputProps) {
  const { avgCmc, cheapDrawCount, suggestedCount } = hint;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const parsed = parseInt(e.target.value, 10);
    if (!isNaN(parsed) && parsed >= 1 && parsed <= 100) {
      onChange(parsed);
    }
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-1">
        Total land count
      </label>
      <input
        type="number"
        min={1}
        max={100}
        value={value}
        onChange={handleChange}
        className="w-24 bg-gray-800 border border-gray-700 rounded-lg px-3 py-1.5 text-sm text-gray-200 focus:outline-none focus:border-orange-500 transition-colors"
      />
      <p className="text-gray-400 text-xs mt-1">
        Recommended range: 33–38. Based on your deck&apos;s average CMC (
        {avgCmc.toFixed(1)}) and {cheapDrawCount} cheap draw spell
        {cheapDrawCount !== 1 ? 's' : ''}, a good starting point is{' '}
        <span className="text-orange-400 font-medium">{suggestedCount}</span> lands.
      </p>
    </div>
  );
}
